<template>
  <div class="ai-intro">
    <div class="banner">
      <div class="img">
        <img src="https://img.kakaclo.com/web-img/home/ai/bg_img.png" alt="">
      </div>
      <div class="banner-main f-b-c">
        <div class="top">
          <h1 class="title" style="height:auto">{{ $t('AI.Banner.Title1') }}</h1>
          <div>{{ $t('AI.Banner.Text1') }}</div>
        </div>
        <div class="bottom f-c-c">
          <div class="item">
            <div class="f-c-c fd-c">
              <img src="https://img.kakaclo.com/web-img/home/ai/intro_icon1.png" alt="">
              <h4 class="title">{{ $t('AI.Banner.Title2') }}</h4>
              <div class="subhead">{{ $t('AI.Banner.Text2') }}</div>
            </div>
            <div class="btn">
              <photograph>
                {{ $t('AI.Banner.TryNow') }} <i class="el-icon-right"></i>
              </photograph>
            </div>
          </div>
          <div class="item">
            <div class="f-c-c fd-c">
              <img src="https://img.kakaclo.com/web-img/home/ai/intro_icon2.png" alt="">
              <h4 class="title">{{ $t('AI.Banner.Title3') }}</h4>
              <div class="subhead">{{ $t('AI.Banner.Text3') }}</div>
            </div>
            <div class="btn pointer" @click="jump('/ai-designer')">{{ $t('AI.Banner.TryNow') }} <i class="el-icon-right"></i></div>
          </div>
          <div class="item">
            <div class="f-c-c fd-c">
              <img src="https://img.kakaclo.com/web-img/home/ai/intro_icon3.png" alt="">
              <h4 class="title">{{ $t('AI.Banner.Title4') }}</h4>
              <div class="subhead">{{ $t('AI.Banner.Text4') }}</div>
            </div>
            <div class="btn pointer" @click="jump('/mall/explore')">{{ $t('AI.Banner.TryNow') }} <i class="el-icon-right"></i></div>
          </div>
          <div class="item">
            <div class="f-c-c fd-c">
              <img src="https://img.kakaclo.com/web-img/home/ai/intro_icon4.png" alt="">
              <h4 class="title">{{ $t('AI.Banner.Title5') }}
                <div class="tag">{{ $t('AI.Banner.ComingSoon') }}</div>
              </h4>
              <div class="subhead">{{ $t('AI.Banner.Text5') }}</div>
            </div>
          </div>
          <div class="item">
            <div class="f-c-c fd-c">
              <img src="https://img.kakaclo.com/web-img/home/ai/intro_icon5.png" alt="">
              <h4 class="title">{{ $t('AI.Banner.Title6') }}
                <div class="tag">{{ $t('AI.Banner.ComingSoon') }}</div>
              </h4>
              <div class="subhead">{{ $t('AI.Banner.Text6') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="module1 f-c-c fd-c">
      <div class="title">
        <h2>{{ $t('AI.Module.Title1') }}</h2>
        <img src="https://img.kakaclo.com/web-img/home/ai/intro_icon6.png" alt="">
      </div>
      <div class="subhead">{{ $t('AI.Module.Text1') }}</div>
      <photograph>
        <el-button type="primary" class="elbtn">
          {{ $t('AI.Module.UploadImage') }}
        </el-button>
      </photograph>
      <div class="img" style="position: relative;top: -110px;z-index: -1;">
        <img src="https://img.kakaclo.com/web-img/home/ai/intro_img1.png" alt="">
      </div>
    </div>

    <div class="module2 f-c-c fd-c">
      <div class="title">
        <h2>{{ $t('AI.Module.Title2') }}</h2>
        <div class="tag">{{ $t('AI.Banner.ComingSoon') }}</div>
        <img src="https://img.kakaclo.com/web-img/home/ai/intro_icon6.png" alt="">
      </div>
      <div class="subhead">{{ $t('AI.Module.Text2') }}</div>
      <div class="img">
        <img src="https://img.kakaclo.com/web-img/home/ai/intro_img2.png" alt="">
      </div>
    </div>

    <div class="module3">
      <img class="bg-img" src="https://img.kakaclo.com/web-img/home/ai/bg_img2.png" alt="">
      <div class="intro">
        <div class="title f">
          <h2>{{ $t('AI.Module.Title3') }}</h2>
          <img src="https://img.kakaclo.com/web-img/home/ai/intro_icon6.png" alt="">
        </div>
        <div class="subhead">{{ $t('AI.Module.Text3') }}</div>
        <el-button class="elbtn" type="primary" @click="jump('/ai-designer')">{{ $t('AI.Banner.TryNow') }}</el-button>
      </div>
      <img class="img" src="https://img.kakaclo.com/web-img/home/ai/intro_img3.png" alt="">
    </div>

    <div class="module4">
      <div class="title f-c-c">
        <h2>{{ $t('AI.Module.Title4') }}</h2>
        <img src="https://img.kakaclo.com/web-img/home/ai/intro_icon6.png" alt="">
        <div class="tag">{{ $t('AI.Banner.ComingSoon') }}</div>
      </div>
      <div class="top f">
        <div class="name">
          <h4>{{ $t('AI.Module.Title5') }}</h4>
        </div>
        <div class="cont f-c-c">
          <div class="left">
            <img src="https://img.kakaclo.com/web-img/home/ai/intro_img4.png" alt="">
            <div class="intro">
              <h4>{{ $t('AI.Module.Title6') }}</h4>
              <div>{{ $t('AI.Module.Text6') }}</div>
            </div>
          </div>
          <div class="right">
            <div class="img1">
              <img src="https://img.kakaclo.com/web-img/home/ai/intro_img5.png" alt="">
              <div class="intro">
                <h4>{{ $t('AI.Module.Title7') }}</h4>
                <div>{{ $t('AI.Module.Text7') }}</div>
              </div>
            </div>
            <div class="img2">
              <img src="https://img.kakaclo.com/web-img/home/ai/intro_img6.png" alt="">
              <div class="intro">
                <h4>{{ $t('AI.Module.Title8') }}</h4>
                <div>{{ $t('AI.Module.Text8') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom f">
        <div style="width:23%">
          <img src="https://img.kakaclo.com/web-img/home/ai/intro_img7.png" alt="">
          <div class="intro">
            <h4>{{ $t('AI.Module.Title9') }}</h4>
            <div>{{ $t('AI.Module.Text9') }}</div>
          </div>
        </div>
        <div style="width:26.46%">
          <img src="https://img.kakaclo.com/web-img/home/ai/intro_img8.png" alt="">
          <div class="intro">
            <h4>{{ $t('AI.Module.Title10') }}</h4>
            <div>{{ $t('AI.Module.Text10') }}</div>
          </div>
        </div>
        <div style="width:26.46%">
          <img src="https://img.kakaclo.com/web-img/home/ai/intro_img9.png" alt="">
          <div class="intro">
            <h4>{{ $t('AI.Module.Title11') }}</h4>
            <div>{{ $t('AI.Module.Text11') }}</div>
          </div>
        </div>
        <div style="width:24.28%">
          <h4>{{ $t('AI.Module.Title12') }}</h4>
        </div>
      </div>
    </div>

    <div class="module5">
      <div class="cont">
        <img src="https://img.kakaclo.com/web-img/home/ai/intro_img10.png" alt="">
        <div class="intro f-c-c fd-c">
          <div class="title">
            <h2>{{ $t('AI.Module.Title13') }}</h2>
            <img src="https://img.kakaclo.com/web-img/home/ai/intro_icon6.png" alt="">
          </div>
          <div class="subhead">
            {{ $t('AI.Module.Text13') }}
          </div>
          <el-button class="elbtn" type="primary" @click="jump('/mall/explore')">{{ $t('AI.Banner.TryNow') }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Photograph from '../../index/components/Photograph.vue'
export default {
  components: { Photograph },
  data() {
    return {}
  },
  methods: {
    jump(type) {
      this.$router.push(type)
    }
  }
}
</script>

<style lang="scss" scoped>
.ai-intro {
  font-family: 'PingFang SC', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif';
  min-width: 1200px;
  padding-bottom: 80px;
  .banner {
    min-width: 1200px;
    min-height: 1200px;
    position: relative;
    padding-top: 20%;
    margin-bottom: 120px;

    .img{
      position: absolute;
      z-index: -1;
      top: 0;
      width: 100%;
      img {
        display: block;
        width: 100%;
      }
    }

    .banner-main {
      margin: 0 auto;
      font-size: 20px;
      display: flex;
      flex-direction: column;

      .top {
        color: #fff;
        text-align: center;
        margin-bottom: 8%;

        .title {
          margin-bottom: 16px;
          padding: 0 80px;
        }
      }

      .bottom {
        width: 90%;
        max-width: 1500px;
        flex-wrap: wrap;
        padding-left: 10px;

        .item {
          width: 450px;
          height: 370px;
          border-radius: 12px;
          border: 2px solid #fff;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-direction: column;
          padding: 32px;
          padding-bottom: 28px;
          background: rgba(249,251,247,0.5);
          margin-right: 16px;
          margin-bottom: 16px;

          img {
            width: 40px;
            height: 40px;
            margin-bottom: 12px;
          }

          .title {
            margin-bottom: 16px;
            color: #303133;

            .tag {
              top: 13px;
              right: -95px;
              font-weight: 500;
            }
          }

          .subhead {
            font-size: 18px;
            color: #606266;
            line-height: 28px;
          }

          .btn {
            font-size: 18px;
            color: #303133;
            i {
              font-weight: bold;
            }
            &:hover {
              color: #B8D56F;
            }
          }
        }
      }
    }
  }

  .module1, .module2 {
    max-width: 1500px;
    margin: 0 auto;

    .title {
      width: 425px;
    }

    .subhead {
      max-width: 800px;
      text-align: center;
      margin: 28px 0 32px 0;
    }

    .img {
      width: 90%;
      img {
        width: 100%;
      }
    }
  }

  .module2 {
    margin-top:10px;
    .img {
      width: 55%;
      margin-top: 30px;
    }
    .title {
      width: 288px;
      .tag {
        top: 16px;
        right: -66px;
      }
    }
  }

  .module3 {
    width: 100%;
    position: relative;
    margin-top: 120px;

    .bg-img {
      width: 100%;
      max-height: 1000px;
    }
    .intro {
      position: absolute;
      left: 12%;
      top: 10%;
      width: 45%;

      .title {
        width: 310px;
        justify-content: start;
      }

      .subhead {
        max-width: 630px;
        width: 90%;
        margin: 28px 0 32px 0;
      }
    }
    .img {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 12%;
      margin: auto;
      height: 78%;
    }
  }

  .module4 {
    width: 100%;
    margin-top: 80px;

    .title {
      width: 288px;
      text-align: center;
      margin: 0 auto;
      margin-bottom: 40px;
      .tag {
        top: 16px;
        right: -66px;
      }
    }

    .top {
      width: 100%;
      .name {
        box-sizing: border-box;
        width: 23%;
        background-color: #E1F3EC;
        padding-top: 40px;
        h4 {
          text-align: right;
          padding-right: 40px;
        }
      }
      .cont {
        width: 77%;
        .left {
          position: relative;
          width: 40.35%;
          img {
            width: 100%;
          }
        }
        .right {
          width: 59.65%;
          img {
            width: 100%;
          }
          .img1, .img2 {
            position: relative;
          }
        }
      }
    }

    .bottom {
      width: 100%;

      >div {
        position: relative;
        box-sizing: border-box;
        background-color: #EAF3E1;
        >img {
          width: 100%;
        }
        >h4 {
          margin-top: 40px;
          margin-left: 40px;
        }
      }
    }

    .intro {
      width: 100%;
      padding: 40px;
      padding-top: 50px;
      position: absolute;
      bottom: 0;
      color: #fff;
      font-size: 16px;
      background: linear-gradient(0, #303133 0%, rgba(48,49,51,0) 100%);
      div {
        margin-top: 8px;
      }
    }
  }

  .module5 {
    width: 100%;
    background-color: #D7EAA8;
    margin-top: 80px;
    .cont {
      width: 70%;
      margin: 0 auto;
      position: relative;
      >img {
        width: 100%;
      }

      .intro {
        position: absolute;
        color: #fff;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;

        .title{
          width: 380px;
        }

        .subhead {
          margin: 28px 0 32px 0;
          color: #fff;
          max-width: 820px;
          width: 60%;
          min-width: 700px;
          text-align: center;
        }
      }
    }
  }
  h1, h2, h4 {
    margin: 0;
    padding: 0;
  }
  h1 {
    font-size: 52px;
  }
  h2 {
    font-size: 40px;
    font-weight: 700;
  }
  h4 {
    font-size: 26px;
  }

  .title {
    height: 48px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    h2 {
      position: absolute;
      z-index: 1;
    }
    img {
      width: 108px;
      height: 36px;
      position: absolute;
      right: 0px;
      top: 16px;
      z-index: 0;
    }

    .tag {
      position: absolute;
      top: 8px;
      right: -102px;
      font-size: 12px;
      color: #9AC331;
      background-color: #F5F9EA;
      height: 20px;
      border-radius: 9px;
      text-align: center;
      line-height: 20px;
      padding: 0 8px;
      z-index: 1;
    }
  }
  .subhead {
    font-size: 18px;
    color: #606266;
    line-height: 28px;
  }
  .elbtn {
    height: 40px;
    font-size: 14px;
    border-radius: 0;
  }

  img {
    display: block;
  }
}
</style>
